import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  heading: {
    marginBottom: theme.spacing(1)
  },
  chart: {
    // A floor, not a fixed height: ResponsiveContainer is given a computed height per chart
    // so a two-promotion chart is not stretched to the height of an eight-promotion one.
    width: '100%'
  }
}))

export default useStyles
